import React, { useState } from 'react';
import './App.css';
import Menu from './components/Menu';
import axios from 'axios';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand, Button, Alert } from 'reactstrap';
import constants from './helpers/Constants';
import helpers from "./helpers/Utilities";
import AWS from 'aws-sdk';

function Foto() {

    AWS.config.update({
        accessKeyId: constants.S3Key,
        secretAccessKey: constants.S3Secret
    });

    const myBucket = new AWS.S3({
        params: { Bucket: constants.S3Bucket},
        region: constants.S3Region,
    });

    const id = JSON.parse(localStorage.getItem('usuario_logado')).id_associado;

    const [menu, setMenu] = useState(false);
    const [erro, setErro] = useState(false);
    const [sucesso, setSucesso] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const toggleMenu = () => { setMenu(!menu); };
    const handleEnviar = (e) => {
        //setErro(true);

        const params = {
            ACL: 'public-read',
            Body: selectedFile,
            Bucket: constants.S3Bucket,
            Key: helpers.uuid() + '_' + selectedFile.name
        };

        myBucket.putObject(params, (err, data) => {
            if (err) {
                console.log(err);
                setErro(true);
            }
            else{
                setSucesso(true);
                const url = constants.S3URL + params.Key;

                let usuario = JSON.parse(localStorage.getItem('usuario_logado'));
                usuario.foto = url;
                localStorage.setItem('usuario_logado', JSON.stringify(usuario));

                axios({
                    method: 'post',
                    url: constants.APIURLExec,
                    headers: {
                        'APITOKEN': constants.APIToken
                    },
                    data: {
                        cmd: `update associado set foto = '${url}' where id_associado = '${id}'`
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        });
        
    };

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Enviar Foto</NavbarBrand>
                </Navbar>
                <Container>
                    <Row>
                        <Col className="mt-3">
                            <input type="file" id="upload" onChange={(e) => {setSelectedFile(e.target.files[0]);}} hidden/>
                            <label className="file-input" htmlFor="upload">Selecionar Foto</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Button onClick={handleEnviar} className="btn btn-block btn-lg btn-primary btn-azul">ENVIAR</Button>
                        </Col>
                    </Row>
                    { erro && 
                    <Row>
                        <Col className="mt-3">
                            <Alert color="danger">
                                Ocorreu um erro ao enviar sua foto. Tente novamente em instantes.
                            </Alert>
                        </Col>
                    </Row>
                    }
                    { sucesso && 
                    <Row>
                        <Col className="mt-3">
                            <Alert color="success">
                                Foto atualizada com sucesso.
                            </Alert>
                        </Col>
                    </Row>
                    }

                </Container>
            </div>
        </div>
    );
}

export default Foto;
